<template>
	<div class="title-header">
		<div class="wrapper" :class="{ 'pb-0': pbZero }">
			<div class="tw-w-full">
				<img :src="urlImage" :alt="urlImage" v-if="urlImage" class="mr-2">
				<span
					class="text"
					:style="`color:${gray ? $appColors.info : $appColors.primary}`"
				>
					{{ title }} <span class="subtitle-header" v-if="pollName">- {{ pollName }}</span>
				</span>
			</div>
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default {
	name: 'p-title-header',
	props: {
		gray: {
			type: Boolean,
			default: false,
		},
		pbZero: {
			type: Boolean,
			default: false,
		},
		pollName: String,
		title: String,
		urlImage: String,
	},
};
</script>
<style lang="scss" scoped>
	.title-header {
		.text {
			font-family: font(bold);
			font-size: size(xlarge);
		}

		.wrapper {
			align-items: center;
			border-bottom: 1px solid color(border-gray);
			display: flex;
			justify-content: space-between;
			padding: 0 5px 10px;

			&.pb-0 {
				padding-bottom: 0px;
			}
		}
	}

	.subtitle-header {
		font-family: font(regular);
		font-size: size(xlarge);
	}
</style>





// WEBPACK FOOTER //
// src/modules/job-profile/components/content/p-title-header.vue